module.exports = __webpack_public_path__ + "static/media/hs-selector-color.25fdfc70.png";